module.exports = __webpack_public_path__ + "static/media/icon-vertical-dots.f428eba7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/cart/table-card/icon-vertical-dots.svg
// module id = 414
// module chunks = 0 1 2